function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 6a4 4 0 00-8 0m0 4.5v3m8-3v3m5-1.5v3.6c0 2.24 0 3.36-.436 4.216a4 4 0 01-1.748 1.748C17.96 22 16.84 22 14.6 22H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 01-1.748-1.748C3 18.96 3 17.84 3 15.6V12m2 0h14c.932 0 1.398 0 1.765-.152a2 2 0 001.083-1.083C22 10.398 22 9.932 22 9v0c0-.932 0-1.398-.152-1.765a2 2 0 00-1.083-1.083C20.398 6 19.932 6 19 6H5c-.932 0-1.398 0-1.765.152a2 2 0 00-1.083 1.083C2 7.602 2 8.068 2 9v0c0 .932 0 1.398.152 1.765a2 2 0 001.083 1.083C3.602 12 4.068 12 5 12z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
});

var SvgEntitiesAndGroups = function SvgEntitiesAndGroups(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    stroke: "#9193A9"
  }, props), _ref);
};

export default SvgEntitiesAndGroups;